import { isDescriptionSignatureValid } from './security'

const DESCRIPTION_FIELD = 'description'
const SIGNATURE_FIELD = 'descriptionEnc'
const INTEGRITY_FLAG_FIELD = 'descriptionIntegrityValid'

const isObject = (value) =>
  !!value && typeof value === 'object' && !Array.isArray(value)

const shouldCheckNode = (node) =>
  Object.prototype.hasOwnProperty.call(node, SIGNATURE_FIELD)

export const validateDescriptionIntegrity = (payload) => {
  const invalidNodes = []
  const visited = new WeakSet()

  const processNode = (node, path) => {
    if (!node || typeof node !== 'object') {
      return
    }
    if (visited.has(node)) {
      return
    }
    visited.add(node)

    if (shouldCheckNode(node)) {
      const signature = node[SIGNATURE_FIELD]
      const descriptionValue = node[DESCRIPTION_FIELD]
      const isValid = isDescriptionSignatureValid(descriptionValue, signature)
      node[INTEGRITY_FLAG_FIELD] = isValid
      if (!isValid) {
        node[DESCRIPTION_FIELD] = ''
        invalidNodes.push({ path, signature })
      }
    }

    Object.entries(node).forEach(([key, value]) => {
      const nextPath = path ? `${path}.${key}` : key
      if (Array.isArray(value)) {
        value.forEach((child, index) => {
          processNode(child, `${nextPath}[${index}]`)
        })
      } else if (isObject(value)) {
        processNode(value, nextPath)
      }
    })
  }

  if (Array.isArray(payload)) {
    payload.forEach((item, index) => processNode(item, `root[${index}]`))
  } else if (isObject(payload)) {
    processNode(payload, 'root')
  }

  return {
    invalidCount: invalidNodes.length,
    invalidNodes,
  }
}

